<template>
  <loader v-if="loading"/>
  <div v-else-if="error">
    <server-error/>
  </div>
  <div v-else class="eoy2025-page">
    <dynamic-component-viewer
      ref="dynamicComponentViewer"
      :component-name="componentName"
      :extra-params="extraParams"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Segment from '@/Segment';
import DynamicComponentViewer from '@/components/DynamicComponentViewer.vue';
import consts from '@/store/utilities/constants';
import ServerError from '@/pages/general-errors/ServerError.vue';
import Loader from '@/base-components/Loader';
import DDLogs from '@/DDLogs';

export default {
  name: 'EOY2025Page',
  components: {
    DynamicComponentViewer,
    ServerError,
    Loader,
  },
  data() {
    return {
      componentName: consts.DYNAMIC_COMPONENT_NAMES.EOY_2025,
      loading: true,
      error: null,
      userYear: 2025,
    };
  },
  computed: {
    ...mapGetters('mortgages', ['hasMortgageAlternatives', 'totalDiscountTotals']),
    ...mapGetters('session', ['activeMemberFirstName']),

    extraParams() {
      return {
        userYear: this.userYear,
        memberName: this.activeMemberFirstName,
        hasMortgageAlternatives: this.hasMortgageAlternatives,
        totalDiff: this.totalDiscountTotals?.totalDiff || 0,
      };
    },
  },
  async created() {
    Segment.trackUserInteraction('EOY2025Page_Entered');

    try {
      await this.fetchMortgageSimulations();
    } catch (error) {
      DDLogs.error('Failed to fetch mortgage simulations:', error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions('mortgages', ['fetchMortgageSimulations']),
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";

.eoy2025-page {
  height: 100%;
  background: $riseup_white;
  flex-grow: 1;
}
</style>
